import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import { MenuItem, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import RegisterButton from '../../components/atoms/RegisterButton';
import { getAccounts } from '../../actions/Accounts';
import {
  gochiImportFile,
  getGenGochis,
  updateGenGochis,
  UPDATE_GEN_GOCHI_SUCCESS,
  GET_GEN_GOCHI_SUCCESS
} from '../../actions/Gochis';
import '../../stylesheets/csv.css';
import SearchButton from '../../components/atoms/SearchButton';
import GenGochiTable from '../organisms/GenGochiTable';
import genGochiStatuses from '../../constants/GenGochiStatuses';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px',
    maxWidth: 700
  },
  description: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left'
    // float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  inputContainer: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexColumnRevert: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  searchFormContainer: {
    backgroundColor: '#fff',
    margin: 15
  },
  horizotalLine: {
    borderBottom: '15px solid #DBDBDB'
  }
});

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories,
      gochiUserTypes: state.gochis.gochiUserTypes
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          gochiImportFile,
          getGenGochis,
          updateGenGochis
        },
        dispatch
      )
    })
  ),
  withState('file', 'setFile', null),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('gochiUserType', 'setGochiUserType', null),
  withState('gochiRegisterId', 'setGochiRegisterId', null),
  withState('gochiUserId', 'setGochiUserId', null),
  withState('shopId', 'setShopId', null),
  withState('startTime', 'setStartTime', null),
  withState('createdAt', 'setCreatedAt', null),
  withState('status', 'setStatus', null),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', true),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      console.log(data);
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const searchKey = {
        gochiUserType: props.gochiUserType,
        gochiRegisterId: props.gochiRegisterId,
        gochiUserId: props.gochiUserId,
        shopId: props.shopId,
        createdAt: props.createdAt,
        startTime: props.startTime,
        status: props.status,
        page,
        limit: limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getGenGochis(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_GEN_GOCHI_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    account,
    classes,
    file,
    setFile,
    resultMessage,
    setResultMessage,
    checkSession,
    openDrawer,
    updateOpenDrawer,
    openProgress,
    openTable,
    updateOpenTable,
    updateOpenProgress,
    loading,
    updateLoading,
    gochiUserTypes,
    gochiUserType,
    setGochiUserType,
    gochiRegisterId,
    setGochiRegisterId,
    gochiUserId,
    setGochiUserId,
    shopId,
    setShopId,
    startTime,
    setStartTime,
    createdAt,
    setCreatedAt,
    status,
    setStatus,
    handleChangePage,
    page,
    rowsPerPage,
    setRowsPerPage
  }) => {
    const handleChangeGenGochiStatus = (genGochiIds, targetStatus) => {
      const key = {
        genGochiIds,
        status: targetStatus
      };
      updateLoading(true);
      updateOpenProgress(true);
      actions.updateGenGochis(key).then(data => {
        checkSession(data);
        if (data.type === UPDATE_GEN_GOCHI_SUCCESS) {
          setResultMessage('更新しました。');
          updateLoading(false);
          updateOpenTable(true);
        } else {
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        }
      });
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    const registerAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .gochiImportFile(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === 'ADD_GOCHI_IMPORT_FILE_SUCCESS') {
          setResultMessage(uploadedFile.payload.message);
          updateLoading(false);
        } else {
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            ごちファイルアップロード
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchFormContainer}>
            {/* <h2>ごちデータCSVファイルのアップロードツール</h2>
          <br />
          <br /> */}
            <div className={classes.flex}>
              <div className={classes.searchForm}>
                <TextField
                  select
                  label="ごちユーザータイプ"
                  className={classes.textField}
                  margin="normal"
                  value={gochiUserType}
                  onChange={e => {
                    setGochiUserType(e.target.value);
                  }}
                >
                  {gochiUserTypes.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <TextField
                  label="ごちるユーザーID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={gochiRegisterId}
                  onChange={e => {
                    setGochiRegisterId(e.target.value);
                  }}
                />
                <TextField
                  label="ごちられるユーザーID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={gochiUserId}
                  onChange={e => {
                    setGochiUserId(e.target.value);
                  }}
                />
                <TextField
                  label="店舗ID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopId}
                  onChange={e => {
                    setShopId(e.target.value);
                  }}
                />
                <TextField
                  label="インポート時間"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  value={createdAt}
                  onChange={e => {
                    setCreatedAt(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  label="予約実施時間"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  value={startTime}
                  onChange={e => {
                    setStartTime(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  select
                  label="ステータス"
                  className={classes.textField}
                  margin="normal"
                  value={status}
                  onChange={e => {
                    setStatus(e.target.value);
                  }}
                >
                  <MenuItem id="">選択なし</MenuItem>
                  {genGochiStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
              </div>
              <div className={`${classes.flex} ${classes.inputContainer}`}>
                <div className={classes.flexRow}>
                  <input
                    type="file"
                    onChange={e => {
                      setFile(e.target.files[0]);
                    }}
                    onClick={e => {
                      e.target.value = '';
                    }}
                  />
                  <RegisterButton onClickAction={registerAction} />
                </div>
              </div>
            </div>
            <div className={classes.description}>
              ※ごち生成ジョブの仕様
              <br />
              ・5分に1回実行して、毎回100件を処理する
              <br />
              ※1回でアップロードできるのは1000件まで
            </div>
          </div>
          <div className={classes.horizotalLine} />
          {openTable && (
            <GenGochiTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              handleChangeGenGochiStatus={handleChangeGenGochiStatus}
              setResultMessage={setResultMessage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
            />
          )}
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
